<template>
  <div class="page">
    <div class="video-cell">
      <video
        id="myVideo"
        ref="myVideo"
        controlslist="nodownload nofullscreen noremoteplayback"
        disablepictureinpicture="true"
        :poster="fileInfo.cover"
        @click="operateVideo"
        :src="fileInfo.localUrl || video_url"
      />
      <img
        class="paly-icon"
        @click="operateVideo"
        v-if="!videoState"
        src="../../assets/images/popularize/paly.png"
      />
    </div>
    <l-file-upload
      accept="video/mp4"
      ref="videoUpload"
      :beforeUpload="videoBeforeUpload"
      :module="3"
      @onSuccess="videoSuccess($event, arguments)"
      @startUpload="videoStartUpload()"
      @onFaild="videoOnFaild()"
    >
      <div class="local-but">自己拍</div>
    </l-file-upload>

    <!-- <div class="but2" @click="onMaterialLibrary">从素材库选</div> -->
    <div class="tip">注：所选视频大小限制5s或10M以内</div>
    <div v-if="fileInfo.videoSrc" @click="onSubmit" class="submit">
      立即发布
    </div>
    <!-- <material-library :visible.sync="isMaterialLibrary"></material-library> -->
  </div>
</template>

<script>
import LFileUpload from "../../components/LFileUpload";
// import materialLibrary from "../../components/material-library";
import { getVideoFrame, dataURLtoFile } from "../../utils/videoUtils";
import { Indicator, Toast } from "mint-ui";
import api from "api";
export default {
  components: {
    "l-file-upload": LFileUpload,
    // "material-library": materialLibrary,
  },
  data: () => {
    return {
      // isMaterialLibrary: false,
      id: "", //活动id
      video_url: "", //视频地址
      videoState: false, //视频状态
      fileInfo: {
        title: "",
        introduce: "",
        localUrl: "", //本地连接
        videoSrc: "",
        loading: false,
        tips: "",
        //文件上传标识,可为null
        upload_token: "",
        scale: [], //视频尺寸[宽，高]
        duration: 0, //视频时长
        size: 0,
        cover: "",
      },
    };
  },
  created() {
    document.title = "有惊喜等你！";
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  beforeDestroy() {
    Indicator.close();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      api.request("getHotVideoDetail", { id: this.id }).then((res) => {
        if (res.status === 0) {
          this.video_url = res.data.video_url;
          this.$nextTick(() => {
            this.$refs.myVideo.play();
          });
        }
      });
    },
    /**
     * 视频播放与暂停
     */
    operateVideo() {
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
        this.videoState = true;
      } else {
        this.$refs.myVideo.pause();
        this.videoState = false;
      }
    },
    /**
     * 从素材库选择
     */
    // onMaterialLibrary() {
    //   this.isMaterialLibrary = true;
    // },
    /**
     * 开始上传视频之前
     */
    videoBeforeUpload(files) {
      if (files.length > 1) {
        Toast("单次请上传一个视频文件");
        return false;
      }
      let file = files[0];
      // if (!(file.name.substr(-4).toLocaleLowerCase() == ".mp4" || file.type.substr(-3).toLocaleLowerCase() == 'mp4')) {
      //   Toast("只能上传MP4格式的视频");
      //   return false;
      // }
      if (file.size > 10 * 1024 * 1024) {
        Toast("视频文件大小不超过10M");
        return false;
      }
      let url = URL.createObjectURL(file);
      this.fileInfo.size = file.size;
      this.fileInfo.name = file.name;
      this.fileInfo.localUrl = url;
      getVideoFrame(url)
        .then((res) => {
          this.fileInfo.scale = res.info.scale;
          this.fileInfo.duration = res.info.duration;
          return this.upload(res.frames[0]);
        })
        .then((res) => {
          this.fileInfo.cover = res.data[0].file;
          console.log("******", this.fileInfo.cover);
        });
      return true;
    },
    // 开始上传视频
    videoStartUpload() {
      this.fileInfo.loading = true;
      Indicator.open({
        text: "上传中...",
        spinnerType: "fading-circle",
      });
    },
    // 视频上传成功
    videoSuccess(url, args) {
      this.$refs.myVideo.pause();
      this.videoState = false;
      this.fileInfo.videoSrc = url;
      this.fileInfo.loading = false;
      this.fileInfo.upload_token = args[1];
      Indicator.close();
      console.log("-------", "视频上传完成");
    },
    //视频上传失败
    videoOnFaild() {
      this.emptyVideoFileInfo();
      Indicator.close();
    },
    /**
     * 清空上传视频的数据
     */
    emptyVideoFileInfo() {
      this.fileInfo = {
        name: "",
        introduce: "",
        localUrl: "", //本地连接
        videoSrc: "",
        loading: false,
        tips: "",
        scale: [], //视频尺寸[宽，高]
        duration: 0,
        size: 0,
      };
    },
    //上传文件
    upload(file) {
      let formData = new FormData();
      formData.append("files", dataURLtoFile(file, "jpeg"));
      formData.append("mpkey", "kma");
      formData.append("relation_id", "kma");
      return new Promise((resolve, reject) => {
        api.request(
          "uploadFiles",
          formData,
          (result) => {
            resolve(result);
          },
          (err) => {
            reject(err);
          }
        );
      });
    },
    /**
     * 发布视频
     */
    onSubmit() {
      api
        .request("getHotVideoPublish", {
          id: this.id,
          resource_url: this.fileInfo.videoSrc,
          duration: this.fileInfo.duration,
          cover: this.fileInfo.cover,
        })
        .then((res) => {
          if (res.status === 0) {
            if (res.data.errorCode === 0) {
              window._isVideoPublishSucceed = true;
              this.$router.go(-1);
            } else {
              Toast(res.data.msg || "发布失败");
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.page {
  width: 100vw;
  height: 100vh;
  background: #0b0a10;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-y: scroll;
}
.video-cell {
  width: calc(57vh / 16 * 9);
  height: 57vh;
  position: relative;
  margin-top: 4vh;
}
.video-cell .paly-icon {
  position: absolute;
  width: 96px;
  height: 96px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.video-cell video {
  width: 100%;
  height: 100%;
}
.local-but {
  width: 353px;
  height: 6vh;
  border: 2px solid #f2f3f5;
  border-radius: 3vh;
  line-height: 6vh;
  text-align: center;
  font-size: 2.4vh;
  color: #ffffff;
}
.page >>> .large-file-upload {
  margin-top: 2.4vh;
  width: 353px !important;
  height: 6vh !important;
}

.but2 {
  width: 353px;
  height: 6vh;
  border: 2px solid #f2f3f5;
  background: rgba(255, 245, 245, 0.04);
  border-radius: 3vh;
  line-height: 6vh;
  text-align: center;
  font-size: 2.4vh;
  color: #ff0e6a;
  margin-top: 2.6vh;
}

.tip {
  font-size: 26px;
  color: #999999;
  margin-top: 3.34vh;
}

.submit {
  width: 680px;
  height: 6vh;
  background: linear-gradient(
    145deg,
    #fe7e12 0%,
    #ff017d 40%,
    #fe0163 73%,
    #fc021e 100%
  );
  line-height: 6vh;
  border-radius: 3vh;
  text-align: center;
  font-size: 2.8vh;
  font-weight: bold;
  color: #ffffff;
  margin-top: 1.8vh;
}
</style>
